import type { MemberReadModel } from "@billiard/contracts";
import { ApiRequestError, getMember } from "./api";

export async function readCheckoutMemberAuthority(
  selected: Pick<MemberReadModel, "id" | "memberNumber" | "version" | "walletVersion">,
): Promise<MemberReadModel> {
  const authoritative = await getMember(selected.id);
  if (authoritative.id !== selected.id || authoritative.memberNumber !== selected.memberNumber) {
    throw new ApiRequestError(
      "CHECKOUT_MEMBER_AUTHORITY_IDENTITY_MISMATCH",
      "会员身份无法安全确认，系统没有继续使用旧会员；请返回结账页重新选择会员",
    );
  }
  if (
    authoritative.version < selected.version ||
    authoritative.walletVersion < selected.walletVersion
  ) {
    throw new ApiRequestError(
      "CHECKOUT_MEMBER_AUTHORITY_VERSION_ROLLBACK",
      "会员资料或余额版本无法安全确认，系统没有继续使用旧余额；请返回结账页重新选择会员",
    );
  }
  return authoritative;
}
